// Ensure emotion is loaded before any components
import "@emotion/react";
import "@emotion/styled";

// HeroUI 스타일을 위한 global CSS import
import "../styles/globals.css";

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app";

// 클라이언트 전용 앱 - 기존 app.tsx 방식 사용
const container = document.getElementById("root");
if (!container) throw new Error("Root container not found");

const root = createRoot(container, {
  identifierPrefix: 'edusense-',
  onRecoverableError: (error) => {
    if (error.message.includes('usingClientEntryPoint')) {
      console.warn('React 19 usingClientEntryPoint warning suppressed');
      return;
    }
    console.warn('Recoverable error:', error);
  }
});

root.render(<App />);